export default "__VITE_ASSET__DLniE2TX__"